import { normalizeJoinPolicy } from 'consts';
import type { CallPolicyDraft } from 'state/store';

export type MessengerCallPolicyPayload = {
    joinApprovalPolicy?: string | null;
    onlyModeratorsCanApproveWaitingUsers?: boolean | null;
};

export const callPolicyDraftFromMessenger = (payload?: MessengerCallPolicyPayload | null): CallPolicyDraft => ({
    joinPolicy: normalizeJoinPolicy(payload?.joinApprovalPolicy),
    moderatorsApprovalOnly: Boolean(payload?.onlyModeratorsCanApproveWaitingUsers),
});
